import { NavLink } from "react-router-dom";
import JobZImage from "../../../../common/jobz-img";
import { publicUser } from "../../../../../globals/route-names";
import {loadScript, publicUrlFor, uaLangTranslation, enLangTranslation} from "../../../../../globals/constants";
import { useEffect } from "react";
import CountUp from "react-countup";
import ContactForm from "../../../../common/contact-form";

function Home2Page() {

    useEffect(() => {
        loadScript("js/custom.js");
    })

    const lang = localStorage.getItem('language') || 'en';
    const uaLang = uaLangTranslation;
    const enLang = enLangTranslation;
    const translation = lang === 'en' ? enLang : uaLang;

    return (
        <>
            <div id="home" className="twm-home2-banner-section site-bg-gray bg-cover"
                 style={{backgroundImage: `url(${publicUrlFor("images/main-slider/slider2/bg1.jpg")})`}}>
                <div className="row">
                    {/*Left Section*/}
                    <div className="col-xl-6 col-lg-6 col-md-12">
                        <div className="twm-bnr-left-section">
                            <div className="twm-bnr-title-large"><span
                                className="site-text-primary">{translation.section1.headline1}</span> {translation.section1.headline2}
                            </div>
                            <div className="twm-bnr-discription">{translation.section1.subtitle}</div>
                            <a href="#contact" className="site-button">{translation.section1.cta}</a>
                        </div>
                    </div>
                    {/*right Section*/}
                    <div className="col-xl-6 col-lg-6 col-md-12 twm-bnr-right-section">
                        <div className="twm-bnr2-right-content">
                            <div className="twm-img-bg-circle-area2">
                                <div className="twm-outline-ring-wrap">
                                    <div className="twm-outline-ring-dott-wrap">
                                        <span className="outline-dot-1"/>
                                        <span className="outline-dot-2"/>
                                        <span className="outline-dot-3"/>
                                        {/*Samll Ring Left*/}
                                        <div className="twm-small-ring-l scale-up-center"/>
                                    </div>
                                </div>
                            </div>
                            <div className="twm-home-2-bnr-images">
                                <div className="bnr-image-1">
                                    <JobZImage src="images/main-slider/slider2/right-pic-1.jpg" alt=""/>
                                </div>
                                <div className="bnr-image-2">
                                    <JobZImage src="images/main-slider/slider2/right-pic-2.jpg" alt=""/>
                                </div>
                                <div className="twm-small-ring-2 scale-up-center"/>
                            </div>
                            {/*icon-block-1*/}
                            <div className="twm-bnr-blocks twm-bnr-blocks-position-1">
                                <div className="twm-icon">
                                    <JobZImage src="images/main-slider/slider2/icon-1.png" alt=""/>
                                </div>
                                <div className="twm-content">
                                    <div className="tw-count-number text-clr-sky">
                                        <span className="counter">
                                            <CountUp end={12} duration={10}/>
                                        </span>K+
                                    </div>
                                    <p className="icon-content-info">{translation.section1.stats.partners}</p>
                                </div>
                            </div>
                            {/*icon-block-2*/}
                            <div className="twm-bnr-blocks twm-bnr-blocks-position-2">
                                <div className="twm-icon pink">
                                    <JobZImage src="images/main-slider/slider2/icon-2.png" alt=""/>
                                </div>
                                <div className="twm-content">
                                    <div className="tw-count-number text-clr-pink">
                                        <span className="counter">
                                            <CountUp end={98} duration={10}/>
                                        </span>
                                    </div>
                                    <p className="icon-content-info">{translation.section1.stats.countries}</p>
                                </div>
                            </div>
                            {/*icon-block-3*/}
                            <div className="twm-bnr-blocks-3 twm-bnr-blocks-position-3">
                                <div className="twm-pics">
                                    <span><JobZImage src="images/main-slider/slider2/user/u-1.jpg" alt=""/></span>
                                    <span><JobZImage src="images/main-slider/slider2/user/u-2.jpg" alt=""/></span>
                                    <span><JobZImage src="images/main-slider/slider2/user/u-3.jpg" alt=""/></span>
                                    <span><JobZImage src="images/main-slider/slider2/user/u-4.jpg" alt=""/></span>
                                    <span><JobZImage src="images/main-slider/slider2/user/u-5.jpg" alt=""/></span>
                                    <span><JobZImage src="images/main-slider/slider2/user/u-6.jpg" alt=""/></span>
                                </div>
                                <div className="twm-content">
                                    <div className="tw-count-number text-clr-green">
                                        <span className="counter">
                                            <CountUp end={3} duration={10}/>
                                        </span>K+
                                    </div>
                                    <p className="icon-content-info">{translation.section1.stats.hires}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* JOBS CATEGORIES SECTION START */}
            <div id="expertise" className="section-full p-t120 p-b90 site-bg-gray twm-job-categories-area">
                <div className="container">
                    <div className="wt-separator-two-part">
                        <div className="row wt-separator-two-part-row">
                            <div className="col-xl-5 col-lg-5 col-md-12 wt-separator-two-part-left">
                                {/* title="" START*/}
                                <div className="section-head left wt-small-separator-outer">
                                    <div className="wt-small-separator site-text-primary">
                                        <div>{translation.section2.title}</div>
                                    </div>
                                    <h2 className="wt-title">{translation.section2.subtitle}</h2>
                                </div>
                                {/* title="" END*/}
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-12 wt-separator-two-part-right">
                                <p>{translation.section2.description}</p>
                            </div>
                        </div>
                    </div>
                    <div className="twm-job-categories-section">
                        <div className="job-categories-style1 m-b30">
                            <div className="owl-carousel job-categories-carousel owl-btn-left-bottom ">
                                {/* COLUMNS 1 */}
                                <div className="item ">
                                    <div className="job-categories-block">
                                        <div className="twm-media">
                                            <div className="flaticon-dashboard"/>
                                        </div>
                                        <div className="twm-content">
                                            <span>{translation.section2.industries.it.title}</span>
                                            <p>{translation.section2.industries.it.description}</p>
                                        </div>
                                    </div>
                                </div>
                                {/* COLUMNS 2 */}
                                <div className="item ">
                                    <div className="job-categories-block">
                                        <div className="twm-media">
                                            <div className="flaticon-project-management"/>
                                        </div>
                                        <div className="twm-content">
                                            <span>{translation.section2.industries.marketing.title}</span>
                                            <p>{translation.section2.industries.marketing.description}</p>
                                        </div>
                                    </div>
                                </div>
                                {/* COLUMNS 3 */}
                                <div className="item ">
                                    <div className="job-categories-block">
                                        <div className="twm-media">
                                            <div className="flaticon-note"/>
                                        </div>
                                        <div className="twm-content">
                                            <span>{translation.section2.industries.finance.title}</span>
                                            <p>{translation.section2.industries.finance.description}</p>
                                        </div>
                                    </div>
                                </div>
                                {/* COLUMNS 4 */}
                                <div className="item ">
                                    <div className="job-categories-block">
                                        <div className="twm-media">
                                            <div className="flaticon-customer-support"/>
                                        </div>
                                        <div className="twm-content">
                                            <span>{translation.section2.industries.operations.title}</span>
                                            <p>{translation.section2.industries.operations.description}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* JOBS CATEGORIES SECTION END */}
            {/* GET JOBS SECTION START */}
            <div className="section-full site-bg-white h-page6-getjobs-wrap">
                <div className="h-page6-client-slider-outer">
                    <div className="container">
                        <div className="h-page6-client-slider">
                            <div className="row">
                                <div className="col-xl-4 col-lg-12">
                                    <div className="h-page-6-client-slide-title">
                                        {translation.section3.title}<span className="site-text-primary">{translation.section3.subtitle}</span>
                                    </div>
                                </div>
                                <div className="col-xl-8 col-lg-12">
                                    <div className="owl-carousel home-client-carousel6 owl-btn-vertical-center">
                                        <div className="item">
                                            <div className="ow-client-logo">
                                                <div className="client-logo client-logo-media">
                                                    <JobZImage src="images/client-logo2/w1.png" alt=""/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="item">
                                            <div className="ow-client-logo">
                                                <div className="client-logo client-logo-media">
                                                    <JobZImage src="images/client-logo2/w2.png" alt=""/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="item">
                                            <div className="ow-client-logo">
                                                <div className="client-logo client-logo-media">
                                                    <JobZImage src="images/client-logo2/w3.png" alt=""/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="item">
                                            <div className="ow-client-logo">
                                                <div className="client-logo client-logo-media">
                                                    <JobZImage src="images/client-logo2/w4.png" alt=""/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="item">
                                            <div className="ow-client-logo">
                                                <div className="client-logo client-logo-media">
                                                    <JobZImage src="images/client-logo2/w5.png" alt=""/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="item">
                                            <div className="ow-client-logo">
                                                <div className="client-logo client-logo-media">
                                                    <JobZImage src="images/client-logo2/w6.png" alt=""/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="item">
                                            <div className="ow-client-logo">
                                                <div className="client-logo client-logo-media">
                                                    <JobZImage src="images/client-logo2/w1.png" alt=""/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="item">
                                            <div className="ow-client-logo">
                                                <div className="client-logo client-logo-media">
                                                    <JobZImage src="images/client-logo2/w2.png" alt=""/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="item">
                                            <div className="ow-client-logo">
                                                <div className="client-logo client-logo-media">
                                                    <JobZImage src="images/client-logo2/w3.png" alt=""/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="item">
                                            <div className="ow-client-logo">
                                                <div className="client-logo client-logo-media">
                                                    <JobZImage src="images/client-logo2/w5.png" alt=""/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="about" className="container">
                    <div className="h-page-6-getjobs-wrap">
                        <div className="row">
                            <div className="col-lg-7 col-md-12">
                                <div className="h-page-6-getjobs-left">
                                    <div className="twm-media">
                                        <JobZImage src="images/home-6/get-job-pic.png" alt="#"/>
                                        <div className="twm-media-bg-circle"/>
                                        <div className="twm-media-bg-circle2"/>
                                        <div className="twm-media-bg-circle3">
                                            <div className="rotate-center">
                                                <span className="ring1"/>
                                                <span className="ring2"/>
                                                <span className="ring3"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-12">
                                <div className="h-page-6-getjobs-right">
                                    {/* title="" START*/}
                                    <div className="section-head left wt-small-separator-outer">
                                        <div className="wt-small-separator site-text-primary">
                                            <div>{translation.section4.title}</div>
                                        </div>
                                        <h2 className="wt-title">{translation.section4.headline}</h2>
                                        {translation.section4.body.map((item, index) => (
                                            <p key={index}>{item}</p>
                                        ))}
                                        <h3>{translation.section4.principles.title}</h3>
                                        <p>{translation.section4.principles.transparency}</p>
                                        <p>{translation.section4.principles.resultOriented}</p>
                                        <p>{translation.section4.principles.partnership}</p>
                                        <p>{translation.section4.principles.cta}</p>
                                    </div>
                                    {/* title="" END*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* GET JOBS SECTION SECTION END */}
            {/* HOW IT WORK SECTION START */}
            <div id="work" className="section-full p-t120 p-b90 site-bg-gray twm-how-it-work-area">
                <div className="container">
                    {/* title="" START*/}
                    <div className="section-head center wt-small-separator-outer">
                        <div className="wt-small-separator site-text-primary">
                            <div>{translation.section5.title}</div>
                        </div>
                        <h2 className="wt-title">{translation.section5.headline}</h2>
                    </div>
                    {/* title="" END*/}
                    <div className="twm-how-it-work-section3">
                        <div className="row">
                            <div className="col-xl-4 col-lg-6 col-md-6">
                                <div className="twm-w-process-steps3">
                                    <div className="twm-w-pro-top">
                                        <span className="twm-large-number  text-clr-sky">01</span>
                                        <div className="twm-media bg-clr-sky">
                                            <span><JobZImage src="images/work-process/icon1.png" alt="icon1"/></span>
                                        </div>
                                    </div>
                                    <h4 className="twm-title">{translation.section5.steps[0].title}</h4>
                                    <p>{translation.section5.steps[0].description}</p>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-6">
                                <div className="twm-w-process-steps3">
                                    <div className="twm-w-pro-top">
                                        <span className="twm-large-number text-clr-pink">02</span>
                                        <div className="twm-media bg-clr-pink">
                                            <span><JobZImage src="images/work-process/icon2.png" alt="icon1"/></span>
                                        </div>
                                    </div>
                                    <h4 className="twm-title">{translation.section5.steps[1].title}</h4>
                                    <p>{translation.section5.steps[1].description}</p>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-6">
                                <div className="twm-w-process-steps3">
                                    <div className="twm-w-pro-top">
                                        <span className="twm-large-number  text-clr-green">03</span>
                                        <div className="twm-media  bg-clr-green">
                                            <span><JobZImage src="images/work-process/icon3.png" alt="icon1"/></span>
                                        </div>
                                    </div>
                                    <h4 className="twm-title">{translation.section5.steps[2].title}</h4>
                                    <p>{translation.section5.steps[2].description}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* HOW IT WORK SECTION END */}
            {/* Jobs START */}
            <div id="job-offer" className="section-full p-t120 p-b90 site-bg-white pos-relative twm-bdr-bottom-1">
                <div className="container">
                    {/* title="" START*/}
                    <div className="section-head center wt-small-separator-outer">
                        <div className="wt-small-separator site-text-primary">
                            <div>{translation.section6.headline}</div>
                        </div>
                        <h2 className="wt-title">{translation.section6.subtitle}</h2>
                    </div>
                    {/* title="" END*/}
                    <div className="section-content">
                        <div className="twm-jobs-grid-h5-wrap">
                            <div className="row" style={{'justify-content': 'center'}}>
                                <div className="col-lg-6 col-md-6">
                                    <div className="twm-jobs-st5  m-b30">
                                        <div className="twm-job-st5-top">
                                            <div className="twm-com-info">
                                                <JobZImage src="images/location-dot-solid.svg" />
                                                <p className="twm-job-address">Kyiv, Ukraine</p>
                                            </div>
                                        </div>
                                        <div className="twm-mid-content">
                                            <NavLink to={publicUser.jobs.DETAIL1} className="twm-job-title">
                                                <h4>{translation.section6.jobs[0].title}</h4>
                                            </NavLink>
                                            <div className="twm-job-duration">
                                                <ul>
                                                    <li>
                                                        <span className="twm-job-post-duration"><i
                                                            className="fa fa-calendar-alt"/>{translation.section6.fulltime}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                            <p>{translation.section6.jobs[0].description}</p>
                                        </div>
                                        <div className="twm-right-content">
                                            <NavLink to={publicUser.jobs.DETAIL1}
                                                     className="twm-jobs-browse site-text-primary">{translation.section6.button}</NavLink>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="twm-jobs-st5  m-b30">
                                        <div className="twm-job-st5-top">
                                            <div className="twm-com-info">
                                                <JobZImage src="images/location-dot-solid.svg" />
                                                <p className="twm-job-address">Kyiv, Ukraine</p>
                                            </div>
                                        </div>
                                        <div className="twm-mid-content">
                                            <NavLink to={publicUser.jobs.DETAIL2} className="twm-job-title">
                                                <h4>{translation.section6.jobs[1].title}</h4>
                                            </NavLink>
                                            <div className="twm-job-duration">
                                                <ul>
                                                    <li>
                                                        <span className="twm-job-post-duration"><i
                                                            className="fa fa-calendar-alt"/>{translation.section6.fulltime}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                            <p>{translation.section6.jobs[1].description}</p>
                                        </div>
                                        <div className="twm-right-content">
                                            <NavLink to={publicUser.jobs.DETAIL2}
                                                     className="twm-jobs-browse site-text-primary">{translation.section6.button}</NavLink>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="twm-jobs-st5  m-b30">
                                        <div className="twm-job-st5-top">
                                            <div className="twm-com-info">
                                                <JobZImage src="images/location-dot-solid.svg" />
                                                <p className="twm-job-address">Kyiv, Ukraine</p>
                                            </div>
                                        </div>
                                        <div className="twm-mid-content">
                                            <NavLink to={publicUser.jobs.DETAIL3} className="twm-job-title">
                                                <h4>{translation.section6.jobs[2].title}</h4>
                                            </NavLink>
                                            <div className="twm-job-duration">
                                                <ul>
                                                    <li>
                                                        <span className="twm-job-post-duration"><i
                                                            className="fa fa-calendar-alt"/>{translation.section6.fulltime}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                            <p>{translation.section6.jobs[2].description}</p>
                                        </div>
                                        <div className="twm-right-content">
                                            <NavLink to={publicUser.jobs.DETAIL3}
                                                     className="twm-jobs-browse site-text-primary">{translation.section6.button}</NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Recruiters END */}
            {/* TESTIMONIAL SECTION START */}
            <div id="testimonials" className="section-full p-t120 p-b90 site-bg-white twm-testimonial-v-area">
                <div className="container">
                    <div className="section-content">
                        <div className="twm-testimonial-v-section">
                            <div className="row">
                                <div className="col-xl-5 col-lg-12 col-md-12">
                                    <div className="twm-explore-content-outer2">
                                        <div className="twm-explore-top-section">
                                            {/* title="" START*/}
                                            <div className="section-head left wt-small-separator-outer">
                                                <div className="wt-small-separator site-text-primary">
                                                    <div>{translation.section7.title}</div>
                                                </div>
                                                <h2>{translation.section7.headline}</h2>
                                                <p>{translation.section7.description}</p>
                                                <p>{translation.section7.cta}</p>
                                            </div>
                                            {/* title="" END*/}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-7 col-lg-12 col-md-12">
                                    <div className="v-testimonial-wrap">
                                        <div className="v-testi-dotted-pic">
                                            <JobZImage src="images/home-6/testimonial/dotted-block.png" alt="#"/>
                                        </div>
                                        {/* Swiper */}
                                        <div className="swiper-container v-testimonial-slider">
                                            <div className="swiper-wrapper">
                                                {/*block 1*/}
                                                <div className="swiper-slide">
                                                    <div className="testimonials-v">
                                                        <div className="testimonial-v-content">
                                                            <div className="t-testimonial-top">
                                                                <div className="t-quote"><i
                                                                    className="fa fa-quote-left"/></div>
                                                                <div className="t-rating">
                                                                    <span><i className="fa fa-star"/></span>
                                                                    <span><i className="fa fa-star"/></span>
                                                                    <span><i className="fa fa-star"/></span>
                                                                    <span><i className="fa fa-star"/></span>
                                                                    <span><i className="fa fa-star"/></span>
                                                                </div>
                                                            </div>
                                                            <div className="t-discription">{translation.section7.testimonials[0].text}</div>
                                                            <div className="twm-testi-detail">
                                                                <div className="twm-testi-name">{translation.section7.testimonials[0].author}</div>
                                                                <div className="twm-testi-position">{translation.section7.testimonials[0].position}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/*block 2*/}
                                                <div className="swiper-slide">
                                                    <div className="testimonials-v">
                                                        <div className="testimonial-v-content">
                                                            <div className="t-testimonial-top">
                                                                <div className="t-quote"><i
                                                                    className="fa fa-quote-left"/></div>
                                                                <div className="t-rating">
                                                                    <span><i className="fa fa-star"/></span>
                                                                    <span><i className="fa fa-star"/></span>
                                                                    <span><i className="fa fa-star"/></span>
                                                                    <span><i className="fa fa-star"/></span>
                                                                    <span><i className="fa fa-star"/></span>
                                                                </div>
                                                            </div>
                                                            <div className="t-discription">{translation.section7.testimonials[1].text}</div>
                                                            <div className="twm-testi-detail">
                                                                <div className="twm-testi-name">{translation.section7.testimonials[1].author}</div>
                                                                <div className="twm-testi-position">{translation.section7.testimonials[1].position}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/*block 3*/}
                                                <div className="swiper-slide">
                                                    <div className="testimonials-v">
                                                        <div className="testimonial-v-content">
                                                            <div className="t-testimonial-top">
                                                                <div className="t-quote"><i
                                                                    className="fa fa-quote-left"/></div>
                                                                <div className="t-rating">
                                                                    <span><i className="fa fa-star"/></span>
                                                                    <span><i className="fa fa-star"/></span>
                                                                    <span><i className="fa fa-star"/></span>
                                                                    <span><i className="fa fa-star"/></span>
                                                                    <span><i className="fa fa-star"/></span>
                                                                </div>
                                                            </div>
                                                            <div className="t-discription">{translation.section7.testimonials[2].text}</div>
                                                            <div className="twm-testi-detail">
                                                                <div className="twm-testi-name">{translation.section7.testimonials[2].author}</div>
                                                                <div className="twm-testi-position">{translation.section7.testimonials[2].position}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/*block 4*/}
                                                <div className="swiper-slide">
                                                    <div className="testimonials-v">
                                                        <div className="testimonial-v-content">
                                                            <div className="t-testimonial-top">
                                                                <div className="t-quote"><i
                                                                    className="fa fa-quote-left"/></div>
                                                                <div className="t-rating">
                                                                    <span><i className="fa fa-star"/></span>
                                                                    <span><i className="fa fa-star"/></span>
                                                                    <span><i className="fa fa-star"/></span>
                                                                    <span><i className="fa fa-star"/></span>
                                                                    <span><i className="fa fa-star"/></span>
                                                                </div>
                                                            </div>
                                                            <div className="t-discription">{translation.section7.testimonials[3].text}</div>
                                                            <div className="twm-testi-detail">
                                                                <div className="twm-testi-name">{translation.section7.testimonials[3].author}</div>
                                                                <div className="twm-testi-position">{translation.section7.testimonials[3].position}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/*block 5*/}
                                                <div className="swiper-slide">
                                                    <div className="testimonials-v">
                                                        <div className="testimonial-v-content">
                                                            <div className="t-testimonial-top">
                                                                <div className="t-quote"><i
                                                                    className="fa fa-quote-left"/></div>
                                                                <div className="t-rating">
                                                                    <span><i className="fa fa-star"/></span>
                                                                    <span><i className="fa fa-star"/></span>
                                                                    <span><i className="fa fa-star"/></span>
                                                                    <span><i className="fa fa-star"/></span>
                                                                    <span><i className="fa fa-star"/></span>
                                                                </div>
                                                            </div>
                                                            <div className="t-discription">{translation.section7.testimonials[4].text}</div>
                                                            <div className="twm-testi-detail">
                                                                <div className="twm-testi-name">{translation.section7.testimonials[4].author}</div>
                                                                <div className="twm-testi-position">{translation.section7.testimonials[4].position}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/*block 6*/}
                                                <div className="swiper-slide">
                                                    <div className="testimonials-v">
                                                        <div className="testimonial-v-content">
                                                            <div className="t-testimonial-top">
                                                                <div className="t-quote"><i
                                                                    className="fa fa-quote-left"/></div>
                                                                <div className="t-rating">
                                                                    <span><i className="fa fa-star"/></span>
                                                                    <span><i className="fa fa-star"/></span>
                                                                    <span><i className="fa fa-star"/></span>
                                                                    <span><i className="fa fa-star"/></span>
                                                                    <span><i className="fa fa-star"/></span>
                                                                </div>
                                                            </div>
                                                            <div className="t-discription">{translation.section7.testimonials[5].text}</div>
                                                            <div className="twm-testi-detail">
                                                                <div className="twm-testi-name">{translation.section7.testimonials[5].author}</div>
                                                                <div className="twm-testi-position">{translation.section7.testimonials[5].position}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* Add Pagination */}
                                            <div className="swiper-pagination"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* TESTIMONIAL SECTION END */}
            <ContactForm />

        </>
    )
}

export default Home2Page;